import { z } from 'zod';
import { TASK_STATUS, taskSectionInput } from '../index.js';
export const taskApiRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/task/:taskId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/project/:projectId/task',
        q: z
            .object({
            // filters
            title: z.string().optional(),
            status: z.array(z.enum(TASK_STATUS)).optional(),
            recipientId: z.string().optional(),
            labelId: z.string().optional(),
            dueDate: z
                .enum(['TODAY', 'TOMORROW', 'OVERDUE', 'NO_DUE_DATE'])
                .or(z.string().date())
                .optional(),
            // sort
            orderBy: z
                .object({
                title: z.enum(['asc', 'desc']).optional(),
                dueDate: z.enum(['asc', 'desc']).optional(),
                createdAt: z.enum(['asc', 'desc']).optional(),
            })
                .optional(),
        })
            .strict()
            .optional(),
        output: {},
    },
    create: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task',
        input: z
            .object({
            title: z.string().optional(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
        })
            .strict(),
        output: {},
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId',
        input: z
            .object({
            title: z.string().optional().nullable(),
            recipientName: z.string().optional().nullable(),
            recipientEmail: z.string().optional().nullable(),
            editOption: z.boolean().optional(),
            hideResponseAfterSubmission: z.boolean().optional(),
            autoAccept: z.boolean().optional(),
            dueDate: z.string().optional().nullable(),
            dueDateDaysAfterSend: z.number().optional().nullable(),
            recipientInstructions: z.string().optional().nullable(),
            automaticUpload: z.boolean().optional(),
            apiDeckStoragePath: z.string().optional().nullable(),
            apiDeckDriveId: z.string().optional().nullable(),
            config: z.optional(z.object({ sections: taskSectionInput }).nullable()),
            recipientCadence: z.optional(z
                .object({
                id: z.string(),
                startDate: z.string(),
                utcHour: z.number(),
                minute: z.number(),
                period: z.enum(['DEADLINE', 'DAILY', 'WEEKLY', 'MONTHLY', 'YEARLY']),
                value: z.number().nullable(),
                offset: z.number().nullable(),
                avoidWeekend: z.boolean(),
                enabled: z.boolean(),
            })
                .nullable()),
        })
            .strict(),
        output: {},
    },
    taskSetRecipient: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/recipient',
        input: z.object({
            recipientId: z.string().nullable(),
        }),
        output: {},
    },
    send: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/send',
        output: {},
    },
    sendBulk: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/send-list',
        input: z
            .object({
            taskIds: z.array(z.string()),
        })
            .strict(),
        output: {},
    },
    delete: {
        method: 'DELETE',
        path: '/organization/:organizationId/project/:projectId/task/:taskId',
        output: null,
    },
    duplicate: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/duplicate',
        output: {},
    },
    accept: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/accept',
        output: {},
    },
    sendBack: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/send-back',
        input: z
            .object({
            reason: z.string().nullable().optional(),
        })
            .strict(),
        output: {},
    },
    cancel: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/cancel',
        output: {},
    },
    createFromTaskTemplates: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/create-from-task-template',
        input: z
            .object({
            taskTemplateIds: z.array(z.string()),
        })
            .strict(),
        output: {},
    },
    resendRecipientNotification: {
        method: 'POST',
        path: '/organization/:organizationId/project/:projectId/task/:taskId/resend-recipient-notification',
        output: {},
    },
};
//# sourceMappingURL=task-api-routes.js.map